<template>
  <section
    id="home"
    data-aos="slide-up"
    data-aos-duration="800"
    class="section w-full h-[700px] bg-cover bg-center flex flex-col items-center justify-end text-white"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="absolute inset-0 bg-black bg-opacity-50"></div>
    <div class="relative z-10 text-center">
      <h1
        class="text-md md:text-5xl font-serif mb-2"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        Walimatul 'Ursy'
      </h1>
      <h2
        class="text-4xl md:text-6xl font-cursive font-black"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        Syifa & Hidayat
      </h2>
      <p
        class="text-lg md:text-2xl mb-4"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        {{ eventDateFormatted }}
      </p>
      <CountdownComponent
        :targetDate="eventDateObject"
        class="mt-2"
        @countdownFinished="countdownFinished = true"
      />
      <!-- Tombol Simpan di Kalender -->
      <a
        :href="googleCalendarUrl"
        target="_blank"
        class="inline-flex items-center gap-2 mt-4 mb-10 px-4 py-2 bg-blue-500 text-white font-semibold rounded-full shadow-md hover:bg-blue-800 transition"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <font-awesome-icon
          :icon="['fas', 'calendar']"
          class="text-white mr-2"
        />
        Simpan di Kalender
      </a>

      <blockquote
        class="relative mx-auto text-md md:text-xl italic p-4 rounded-lg bg-gradient-to-t from-blue-400 to-transparent w-full md:max-w-2xl md:bottom-4"
        data-aos="fade-up"
        data-aos-delay="600"
      >
        "Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan
        pasangan-pasangan untukmu dari jenismu sendiri, agar kamu cenderung dan
        merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa kasih dan
        sayang."
      </blockquote>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import CountdownComponent from "./Countdown.vue";
import backgroundImage from "../assets/img/Background_Content.jpg";

const route = useRoute();
const countdownFinished = ref(false);

const eventDate = computed(() => {
  const path = route.path.toLowerCase();
  return path.includes("syifa") ? "2025-06-27T00:00:00" : "2025-06-24T00:00:00";
});

const eventDateFormatted = computed(() => {
  const date = new Date(eventDate.value); // Pastikan gunakan .value di sini
  return date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
});

const eventDateObject = computed(() => new Date(eventDate.value));
const googleCalendarUrl = computed(() => {
  const title = encodeURIComponent("Walimatul 'Ursy Syifa & Hidayat");
  const details = encodeURIComponent("Undangan pernikahan Syifa & Hidayat");
  const location = encodeURIComponent("Lokasi acara pernikahan"); // Optional
  const start = new Date(eventDateObject.value);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000); // +2 jam

  const formatDate = (date: Date) =>
    date
      .toISOString()
      .replace(/[-:]|\.\d{3}/g, "")
      .slice(0, 15) + "Z";

  const dates = `${formatDate(start)}/${formatDate(end)}`;

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${dates}&details=${details}&location=${location}&sf=true&output=xml`;
});
</script>

<!-- <script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import backgroundImage from "../assets/img/Background_Content.jpg";

const route = useRoute();

const eventDate = computed(() => {
  const side = route.params.side?.toString().toLowerCase();
  if (side === "syifa") return "27 Juni 2025";
  return "24 Juni 2025"; // default /hidayat
});
</script> -->

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

@import url("https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Merriweather:wght@700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap");

h1 {
  font-family: "Merriweather", serif;
}

h2 {
  font-family: "Dancing Script", cursive;
}

p {
  font-family: "Roboto", sans-serif;
}

button {
  font-family: "Roboto", sans-serif;
}
</style>
